import { render, staticRenderFns } from "./CertQuery.vue?vue&type=template&id=1f9f487c&scoped=true"
import script from "./CertQuery.vue?vue&type=script&lang=js"
export * from "./CertQuery.vue?vue&type=script&lang=js"
import style0 from "./CertQuery.vue?vue&type=style&index=0&id=1f9f487c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9f487c",
  null
  
)

export default component.exports